module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Shopping/Box2-294c36deefaebebbbf1191128a993d92.svg";